import { useContext } from 'react';
import { ToastContext } from '../components/Notification/ToastProvider';

/**
 * Хук для показа toast-уведомлений.
 *
 *   const { showToast } = useToast();
 *   showToast('Ошибка при сохранении', 'error');
 *   showToast('Сохранено', 'success');
 */
export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return ctx;
}
